export const allUsers = {
  data: [
    {
      id: 0,
      data: {
        userPreferences: {
          username: "catyuan",
          displayName: "Catherine",
          profilePicture:
            "https://pbs.twimg.com/profile_images/1036730403514736650/PCRxFiEt_400x400.jpg",
        },
        studyData: {
          studyTime: 178,
          lastActiveTime: 1595261370008,
        },
      },
    },
    {
      id: 1,
      data: {
        userPreferences: {
          username: "spritefullake",
          displayName: "Talha",
          profilePicture:
            "https://i.ebayimg.com/images/g/UIcAAOSwCU1YnSQS/s-l300.jpg",
        },
        studyData: {
          studyTime: 218,
          lastActiveTime: 1595261170008,
        },
      },
    },
  ],
};

export const myBuddies = {
  data: [
    {
      id: 0,
      data: {
        userPreferences: {
          username: "catyuan",
          displayName: "Catherine",
          profilePicture:
            "https://pbs.twimg.com/profile_images/1036730403514736650/PCRxFiEt_400x400.jpg",
        },
        studyData: {
          studyTime: 178,
          lastActiveTime: 1595261370008,
        },
      },
    },
  ],
};

/**
 * For all groups, the privacy can be - public, private, restricted
 * The members array will only exist for private and restricted groups
 */
export const allGroups = {
  data: [
    {
      id: 0,
      data: {
        isMember: true,
        userPreferences: {
          username: "cs_125",
          displayName: "CS 125",
          profilePicture:
            "https://www.depts.ttu.edu/cs/images/CSslideshowCyber.jpg",
          description: "Lab group AYY Wed: 4pm-6pm",
          privacy: "restricted",
          members: ["j_doe", "catyuan", "spritefullake"],
        },
        studyData: {
          studyTime: 1040,
        },
      },
    },
    {
      id: 1,
      data: {
        isMember: false,
        userPreferences: {
          username: "cs_225",
          displayName: "CS 225",
          profilePicture:
            "https://i.pinimg.com/originals/f8/e7/2e/f8e72e7d126772e56a65295c28020e17.jpg",
          description: "Data Structures Thurs: 2pm-3pm ",
          privacy: "restricted",
          members: ["catyuan", "spritefullake"],
        },
        studyData: {
          studyTime: 878,
        },
      },
    },
  ],
};
